import { IMigrationScript } from '../../../utils/prepareWidgetblockMigrationScripts';
import { DataTableConfigBlockState, DataTableConfigBlockStateOld } from '../types';

const migrateToDirectionalVisualization: IMigrationScript<DataTableConfigBlockStateOld, DataTableConfigBlockState> = (state) => {
    const { useCompassDirection } = state.settings;

    const directionalVisualization = useCompassDirection ? 'cardinal' : 'original';

    const { useCompassDirection: omit, ...settingsWithoutCompassDirection } = state.settings;

    return {
        ...state,
        settings: {
            ...settingsWithoutCompassDirection,
            directionalVisualization,
        },
    };
};

export default migrateToDirectionalVisualization;
